<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Basic data</el-breadcrumb-item>
      <el-breadcrumb-item>plumberCompany Info</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-page-header @back="goBack" :content="title" v-if="visible"></el-page-header>
      <el-divider v-if="visible"></el-divider>
      <!-- 头部查询部分 -->
      <el-form ref="editFormRef" :model="companyInfo" label-width="80px" :rules="editFormRules">
        <div class="left" ref="left">
          <el-form-item label="Company name:" label-width="180px" prop="plumberCompany">
            <el-input :disabled="isDisabled" ref="activeInput" v-model="companyInfo.companyName"></el-input>
          </el-form-item>
          <el-form-item label="Email:" label-width="180px" prop="email">
            <el-input :disabled="isDisabled" ref="activeInput" v-model="companyInfo.email"></el-input>
          </el-form-item>
          <el-form-item label="Testing standard:" label-width="180px" prop="testStandard">
            <el-select
              v-model="companyInfo.testStandard"
              :disabled="isDisabled||isAgency"
              placeholder="please select"
              ref="activeInput"
            >
              <el-option
                v-for="item in testStandardList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Invitation code rules:" label-width="180px" prop="pipelineShortName">
            <el-input
              :disabled="isDisabled||isAgency"
              ref="activeInput"
              v-model="companyInfo.pipelineShortName"
            ></el-input>
          </el-form-item>
          <el-form-item label="Select Area:" label-width="180px" prop="areaList">
            <el-cascader
              filterable
              class="active"
              style="width:100%"
              ref="activeInput"
              clearable
              size="medium"
              :disabled="isDisabled"
              v-model="areaList"
              :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
              :options="areaTreeList"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="Address:" label-width="180px" prop="companyAddress">
            <el-input
              class="active"
              :disabled="isDisabled"
              ref="activeInput"
              v-model="companyInfo.address"
            ></el-input>
          </el-form-item>
        </div>
        <el-button v-if="isDisabled" @click="edit">Edit</el-button>
        <div v-else class="saveAndCancel">
          <el-button @click="updateCompany">Save</el-button>
          <el-button class="cancel" @click="cancel">Cancel</el-button>
        </div>
      </el-form>

      <el-row type="flex" justify="space-between">
        <div class="titleText">Employee Information</div>
        <el-button-group class="btnsList">
          <el-button
            plain
            size="small"
            icon="el-icon-setting"
            v-hasPermission="['company:setting']"
            @click="clickHandlerToSetting"
          >Parameters Setting</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-plus"
            @click="openAddEmployee"
            v-hasPermission="['company:add']"
          >Add Employee</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-unlock"
            @click="enableBatch"
            v-hasPermission="['company:updateStatus']"
          >Enable</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-lock"
            @click="disableBatch"
            v-hasPermission="['company:updateStatus']"
          >Disable</el-button>

          <!-- <el-button
          plain
          size="small"
          icon="el-icon-s-custom"
          @click="cliclHandlerToEngineer"
          >Plumber Management</el-button>-->
        </el-button-group>
      </el-row>

      <!-- 表格数据部分 -->
      <el-table
        ref="multipleTable"
        :data="dataList"
        style="width: 100%"
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="loginAccount" label="Account" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="Email" width="210" show-overflow-tooltip></el-table-column>
        <el-table-column prop="firstName" label="First name" width="180"></el-table-column>
        <el-table-column prop="lastName" label="Last name" width="180"></el-table-column>
        <el-table-column prop="mobile" label="phone number" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="roleName" label="Role permission" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="Status" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='1'" type="success">Enabled</el-tag>
            <el-tag v-else-if="scope.row.status==='2'" type="info">Locked</el-tag>
            <el-tag v-else-if="scope.row.status==='3'" type="warning">Disabled</el-tag>
            <el-tag v-else type="warning"></el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="remark" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="operate" width="220" show-overflow-tooltip fixed="right">
          <template slot-scope="scope">
            <div class="btnContainer">
              <el-link
                icon="el-icon-s-order"
                @click="goDetail(scope.row)"
                v-hasPermission="['company:detail']"
              >Detail</el-link>
              <el-link
                icon="el-icon-edit-outline"
                @click="openEditEmployee(scope.row.id)"
                v-hasPermission="['company:edit']"
              >Edit</el-link>
              <el-link
                icon="el-icon-postcard"
                @click="changePassword(scope.row.id,scope.row.loginAccount,scope.row.email)"
                v-hasPermission="['auth:updateOtherPwd']"
              >resetPwd</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <edit-employee
        ref="editEmployeeDialog"
        :companyId="companyId"
        :dialogTableVisible="dialogTableVisible"
        @closeDialog="closeDialog"
        :title="dialogTitle"
      ></edit-employee>
    </el-card>

    <el-dialog
      title="Reset Password"
      :visible="editPasswordDialogVisible"
      width="30%"
      @close="editPasswordDialogClosed"
    >
      <el-form :model="edit" :rules="editFormRules" ref="editPassFormRef" label-width="50px"  @close="restDialogClosed">
        <el-row>
          <!-- id="displayInput" -->
          <el-input id="displayInput" v-model="updateOtherPwd.userId"></el-input>
          <el-input id="displayInput" v-model="updateOtherPwd.email"></el-input>
          <el-input id="displayInput" v-model="updateOtherPwd.loginAccount"></el-input>
        </el-row>
        <el-form-item label="New Password:" prop="newPassword" label-width="140px">
          <el-input style="width:300px" v-model="updateOtherPwd.newPassword"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editPasswordDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="editPassWord()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import db from '@/services/localstorage'
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
import EditEmployee from '@/views/basic/plumberCompany/EditEmployee.vue'
export default {
  components: {
    Collapse,
    CollapseItem,
    EditEmployee,
  },
  data() {
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 列表
      dataList: [],
      total: 0,
      multipleSelection: [],
      // 默认禁止input输入
      isDisabled: true,
      isAgency: true,
      dialogTitle: '',
      //
      dialogTableVisible: false,
      editEmailDialogVisible: false,
      editPasswordDialogVisible: false,

      title: 'Company info',
      visible: this.$route.query.visible,
      companyId: this.$route.query.companyId,
      agentId: this.$route.query.agentId,
      testStandardList: [],
      areaTreeList: [],
      companyInfo: {},
      areaList: [],
      userType: '',
      updateOtherPwd: {},

      // 添加表单的验证规则对象
      editFormRules: {
        companyName: [
          {
            required: true,
            message: 'Agent name is required',
            trigger: 'blur',
          },
          {
            max: 300,
            message: 'Agent name can not more than 300 character',
            trigger: 'blur',
          },
        ],
        pipelineShortName: [
          {
            required: true,
            message: 'Pipeine code is required',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 3,
            message: 'Only enter three letters character',
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
        ],
        testStandard: [
          {
            required: true,
            message: 'Testing standard is required',
            trigger: 'blur',
          },
        ],
        agencyAddress: [
          {
            required: true,
            message: 'Agency address is required',
            trigger: 'blur',
          },
        ],
        areaList: [
          { required: true, message: 'Area is required', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    console.log(this.visible)
    var user = db.get('user')
    if (undefined == this.companyId || '' == this.companyId) {
      this.companyId = user.companyId
    }
    this.userType = user.userType

    if ('2' == this.userType) {
      this.isAgency = false
    } else {
      this.isAgency = true
    }
    this.search()
  },

  methods: {

     restDialogClosed(){
      this.editPasswordDialogVisible = false
      this.$refs.editFormRef.resetFields()

    },
    // 批量启用账号
    async enableBatch() {
      console.log('multipleSelection', this.multipleSelection)
      console.log('multipleSelection', this.multipleSelection.length)
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select record data')
      }
      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)
      // 弹框询问用户是否启用用户
      const confirmResult = await this.$confirm(
        'Enable, keep continue?',
        'Enable Account',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).catch((err) => err)
      // 如果用户确认 则 返回值为字符串 confirm
      // 如果用户取消 则 返回值为字符串 cancel
      this.$delete(`engineerCompany/startUser`, { idList: ids }).then(
        ({ data: res }) => {
          if (!res.ok) {
            return this.$message.error(res.msg)
          }
          this.$message.success(res.msg)

          this.search()
        }
      )
    },
    // 监听添加用户对话框的关闭事件
    editPasswordDialogClosed() {
      this.editPasswordDialogVisible = false
      this.$refs.editFormRef.resetFields()
    },

    // 批量禁用账号
    async disableBatch() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select record data')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })
      // 弹框询问用户是否启用用户
      const confirmResult = await this.$confirm(
        'Disable, keep continue?',
        'Disable Account',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).catch((err) => err)
      // 如果用户确认 则 返回值为字符串 confirm
      // 如果用户取消 则 返回值为字符串 cancel
      this.$delete(`engineerCompany/stopUser`, { idList: ids }).then(
        ({ data: res }) => {
          if (!res.ok) {
            return this.$message.error(res.msg)
          }
          this.$message.success(res.msg)

          this.search()
        }
      )
    },

    getEntity() {
      var companyId = this.$route.query.companyId
      console.log('companyId:' + companyId)
      if (companyId == undefined || companyId == null) {
        //查询我的水工公司信息，companyId不为空说明是水工公司自己权限查询自己的信息
        this.$get(`engineerCompany/getMyCompany`).then(({ data: res }) => {
          console.log(res)
          this.companyInfo = res.data
          this.company = this.companyInfo.id
          this.areaList = this.companyInfo.areaList
          console.log('companyInfo', this.companyInfo)
          this.search()
        })
      } else {
        //说明是从总部的代理商管理跳转过来查看
        this.$get(
          `engineerCompany/getMyCompany/${this.$route.query.companyId}`
        ).then(({ data: res }) => {
          console.log(res)
          this.companyInfo = res.data
          this.areaList = this.companyInfo.areaList
          console.log('engineerCompany', this.companyInfo)
          this.search()
        })
      }
    },

    async editPassWord() {
      if(this.updateOtherPwd.newPassword==null || this.updateOtherPwd.newPassword==undefined || this.updateOtherPwd.newPassword ==''){
          this.$message.error('Password is required')
          return
      }
      // 弹框询问用户是否发送邮件
      const confirmResult = await this.$confirm(
        'Do you want to email this account?',
        'System prompt',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'NO',
          type: 'warning',
        }
      )
        .then(() => {
          //同意设置需要发送邮件

          this.updateOtherPwd.isSendEmail = 1
          this.updateOtherPwd.newPassword1 = this.updateOtherPwd.newPassword
          console.log(this.updateOtherPwd)
          this.$post(`auth/updateOtherPwd/`, this.updateOtherPwd).then(
            ({ data: res }) => {

              if (res.ok) {
                
                this.editPasswordDialogVisible = false
                this.updateOtherPwd.newPassword = ''
                this.search()
                return this.$message.success(res.msg)
              } else {
             
                this.editPasswordDialogVisible = false
                this.updateOtherPwd.newPassword = ''
                this.search()
                return this.$message.error(res.msg)
              }
            }
          )
        })
        .catch(() => {
          //不同意设置需要不发送邮件
          this.updateOtherPwd.isSendEmail = 0
          this.updateOtherPwd.newPassword1 = this.updateOtherPwd.newPassword
          this.$post(`auth/updateOtherPwd/`, this.updateOtherPwd).then(
            ({ data: res }) => {
              if (res.ok) {
               
                this.editPasswordDialogVisible = false
                this.updateOtherPwd.newPassword = ''
                this.search()
                 return this.$message.success(res.msg)
              } else {
                this.editPasswordDialogVisible = false
                this.updateOtherPwd.newPassword = ''
                this.search()
                 return this.$message.error(res.msg)
              }
            }
          )
        })
    },

    // // 打开更新密码弹框组件
    changePassword(id, loginAccount, email) {
      this.editPasswordDialogVisible = true
      this.updateOtherPwd.userId = id
      this.updateOtherPwd.email = email
      this.updateOtherPwd.loginAccount = loginAccount
    },
    //获取数据字典列表
    getDictList() {
      this.$get(`dict/getByTypeCodeAsFilter/TEST_STANDARD/Y`).then(
        ({ data: res }) => {
          console.log(res)
          this.testStandardList = res.data
        }
      )
    },
    // 打开弹框组件
    openAddEmployee() {
      this.dialogTableVisible = true
      this.dialogTitle = 'Add employee account'
    },
    // 打开弹框组件
    openEditEmployee(id) {
      console.log(id)
      this.dialogTableVisible = true
      this.dialogTitle = 'Edit employee account'
      this.$refs.editEmployeeDialog.setUserId(id)
    },
    // 展示水工公司水工
    goDetail(record) {
      this.$router.push({
        path: '/engineer/engineerInfo',
        query: { companyId: record.companyId, visible: true },
      })
    },

    //获取区域地址信息
    getAreaTreeList() {
      this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(
        ({ data: res }) => {
          console.log(res)
          this.areaTreeList = res.data
        }
      )
    },

    cliclHandlerToEngineer() {
      this.$router.push({
        path: '/engineer/engineerInfo',
        query: { companyId: record.id, visible: true },
      })
    },
    // 监听对话框的关闭事件
    goBack() {
      this.$router.back()
    },
    // 点击跳转到 Plumber界面
    clickHandlerToPlumber() {
      this.$router.push('plumberCompany')
    },
    // 点击设置按钮跳转到setting
    clickHandlerToSetting() {
      this.$router.push({
        path: '/company/parametersetting',
        query: { companyId: this.companyId },
      })
    },
    // 监听子组件关闭弹框
    closeDialog() {
      debugger
      this.dialogTableVisible = false
      this.search()
    },

    cancel() {
      this.isDisabled = true
      this.changeInputStyle()
    },
    //修改代理商信息
    updateCompany() {
      this.companyInfo.areaList= this.areaList;
      this.$refs.editFormRef.validate(async (valid) => {
        debugger
        console.log(this.areaList)
        console.log(valid)
         this.companyInfo.areaFullpath = this.areaList.join(',')
        //需要清空，否则提交后台报错
         
        if (!valid) return
        this.companyInfo.areaList=null
        this.$post('engineerCompany/edit', this.companyInfo).then(
          ({ data: res }) => {
            if (res.msg == 'successfully') {
              // 刷新列表数据
              this.search()
              this.getEntity()
              this.cancel()
              return this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
          }
        )
      })
    },
    // js改变查询框的样式,如果dom结构发生改变，下面代码要检查修改
    changeInputStyle() {
      if (this.isDisabled) {
        for (let i = 0; i < this.$refs.left.children.length; i++) {
          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.border = 'none'

          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.background = '#fff'
        }
      } else {
        for (let i = 0; i < this.$refs.left.children.length; i++) {
          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.border =
            '1px solid #D7D7D7'
          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.background = '#F3F7FF'
        }
      }
    },
    edit() {
      this.isDisabled = false
      this.changeInputStyle()
    },

    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.search()
    },
    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询用户数据列表
    getDataList() {
      debugger
      // 分页查询
      this.queryInfoparams.params.companyId = this.companyId

      this.$post(
        'engineerCompany/myEmployeePageQuery',
        this.queryInfoparams
      ).then(({ data: res }) => {
        this.dataList = res.records
        this.total = res.total
      })
    },
  },
  mounted() {
    console.log(this.$router)
    this.changeInputStyle()
    this.getEntity()
    this.getAreaTreeList()
    this.getDictList()
  },
}
</script>

<style lang='less' scoped>
.el-breadcrumb {
  font-size: 13px;
}
.el-form {
  display: flex;
  .left {
    display: flex;
    width: 90%;
    flex-wrap: wrap;
  }
  .el-form-item {
    margin: 0 10px 20px 0;
    width: 30%;
    /deep/.el-input__inner {
      color: #393838;
    }
    /deep/.el-input__inner::placeholder {
      color: #393838;
    }
  }
  .el-button {
    height: 40px;
  }
  .cancel {
    background: #f2f2f2;
  }
}

i {
  font-size: 22px;
  margin-right: 10px;
}
.saveAndCancel {
  display: flex;
}
.titleText {
  font-size: 14px;
  color: #a4a4a4;
}
.btnsList {
  .el-button {
    margin-left: 10px;
  }
}

.el-pagination {
  display: flex;
  justify-content: flex-end;
}

.btnContainer {
  display: flex;
  justify-content: space-around;
}
/deep/#displayInput {
  display: none;
}
// /deep/#newPassword{
//    display: 300px;
//  }
</style>